// extracted by mini-css-extract-plugin
module.exports = {"userGroup":"UserGroups_userGroup__a7lrt","searchInputWrapper":"UserGroups_searchInputWrapper__21mHY"};